import { Subject } from 'rxjs';
import { KeycloakEventType } from '../interfaces/keycloak-event';

export class KeycloakMockService {
  keycloakEvents$ = new Subject<KeycloakEventType>();

  constructor(
    private username: string,
    private role: string,
  ) {}

  init = () => true;
  isLoggedIn = () => true;
  getUsername = () => this.username;
  getUserRoles = () => [this.role];
  isUserInRole = (role: string) => this.getUserRoles().includes(role);
  logout = () => location.reload();
}
